import React, { Component, Fragment } from "react";

// import Modal from "react-bootstrap/Modal";
import Toast from "react-bootstrap/Toast";

import UBXButton from "./../../ubx/button";
import UBXFormText from "./../../ubx/form/input";
import UBXFormSelect from "./../../ubx/form/select";
import UBXNotice from "./../../ubx/notice";

import User from "./../../user/user";

import { borrowerFeedback } from "./../../../api/borrower";

import { getStaticText } from "./../../../helpers/system";

import {
    FeedbackRatings,
    FeedbackRatingsDetails,
    FeedbackTypeMap,
    FeedbackTypeVarMap,
    FeedbackRatingsLoanAppCompletion,
} from "./../../../config/feedback";

import FeedbackText from "./../../../const/feedback";

import "./../../../assets/css/components/feedback-rating.css";

export default class FeedbackRating extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            showRatingDetails: false,
            ratingReady: false,
            rating: "",
            ratingDetails: "",
            error: false,
        };
    }

    async onChange(name, value) {
        await this.setState({ [name]: value });

        if (name === "rating") {
            await this.setState({ showRatingDetails: FeedbackRatingsDetails.includes(parseInt(value)) });

            if (this.validate()) {
                this.submit();
            }
        }
    }

    async submit() {
        const { rating, ratingDetails } = this.state;
        const { page = false, data = {} } = this.props;
        const { loanId = false, loan = false } = data;

        if (page) {
            const type = FeedbackTypeMap[page];
            const { lenderLogo = {} } = loan;
            const { name: lender = "" } = lenderLogo;

            const submitData = {
                "feedback_type": type,
                "feedback_score": rating,
                "description": ratingDetails,
            };

            if (loan && loanId) {
                submitData["lender"] = lender;
                submitData["loan_id"] = loanId;
            }

            try {
                await borrowerFeedback(submitData);

                const microfeedback = User.getProfileFeedback();

                // let profile = User.getProfile();

                // const { microfeedback = {} } = profile;

                const mfVar = FeedbackTypeVarMap[page];

                switch (page) {
                    case "LoanApplication": {
                        const appForms = microfeedback[mfVar] || [];
                        appForms.push(loanId);

                        microfeedback[mfVar] = appForms;
                        break;
                    }
                    default:
                        microfeedback[mfVar] = true;
                        break;
                }

                // profile = { ...profile, microfeedback };

                // User.setProfile(profile);

                User.setProfileFeedback(microfeedback);

                this.onClose();
            } catch (e) {
                const { response } = e;
                const { data: responseData = {} } = response;
                const { data = {} } = responseData;
                const { message = false } = data;

                let error = "Something went wrong!";
                if (message) {
                    error = message;
                }

                this.setState({ error });
            }
        }
    }

    componentDidUpdate(oldProps) {
        // const { page = false, data = {} } = this.props;
        const { data: oldData = {} } = oldProps;
        const { data = {} } = this.props;

        const { loan: oldDataLoan = false } = oldData;
        const { loan = false } = data;

        if (oldDataLoan || loan) {
            if (oldDataLoan.formCompletion !== loan.formCompletion) {
                this.initialize();
            }
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize() {
        const { page = false, data = {} } = this.props;

        const microfeedback = User.getProfileFeedback();
        // const { microfeedback = false } = User.getProfile();

        if (microfeedback) {
            let show = false;
            switch (page) {
                case "SignUp": {
                    const { sign_up: signUp = false } = microfeedback;
                    if (signUp === false) {
                        show = true;
                    }
                    break;
                }
                case "LoanApplication": {
                    const { app_form: appForm = false } = microfeedback;
                    const { loanId = false, loan = false } = data;

                    if (loanId !== false && loan !== false) {
                        const { formCompletion = 0 } = loan;

                        if (formCompletion >= FeedbackRatingsLoanAppCompletion) {
                            if (!appForm) {
                                show = true;
                            } else if (Array.isArray(appForm) && !appForm.includes(loanId)) {
                                show = true;
                            }
                        }
                    }

                    break;
                }
                default:
                    break;
            }

            this.setState({ show });
        }
    }

    onClose() {
        this.setState({ show: false });
    }

    validate() {
        const { rating, ratingDetails } = this.state;
        let validated = false;

        if (rating !== "") {
            if (FeedbackRatingsDetails.includes(parseInt(rating))) {
                if (ratingDetails !== "") {
                    validated = true;
                }
            } else {
                validated = true;
            }
        }

        return validated;
    }

    renderError() {
        const { error } = this.state;

        let renderedError = "";
        if (error) {
            renderedError = (
                <UBXNotice type="error" show={true}>
                    {error}
                </UBXNotice>
            );
        }

        return renderedError;
    }

    renderRatingDetails() {
        const { showRatingDetails, ratingDetails } = this.state;

        let renderedRatingDetails = "";
        if (showRatingDetails) {
            renderedRatingDetails = (
                <Fragment>
                    <div className="feedback-field" key={`ratingDetails`}>
                        <UBXFormText
                            label={getStaticText(FeedbackText, `RatingLowDetails`, {}, true)}
                            caption={getStaticText(FeedbackText, `RatingLowDetailsCaption`, {}, true)}
                            multiple={true}
                            name="ratingDetails"
                            required={true}
                            onChange={(name, value) => this.onChange(name, value)}
                        />
                    </div>
                    <div className="feedback-button" key={`ratingDetailsButton`}>
                        <UBXButton type="primary" disabled={ratingDetails === ""} onClick={(e) => this.submit(e)}>
                            Send
                        </UBXButton>
                    </div>
                </Fragment>
            );
        }

        return renderedRatingDetails;
    }

    renderContent() {
        const { page } = this.props;

        return (
            <Toast.Body>
                <h3 className="feedback-greeting">{getStaticText(FeedbackText, `RatingTitle_${page}`)}</h3>
                <div className="feedback-field" key={`rating`}>
                    <UBXFormSelect
                        label={getStaticText(FeedbackText, `RatingQuestion_${page}`, {}, true)}
                        type="pill"
                        name="rating"
                        options={FeedbackRatings}
                        optLabel={{ lowest: "Hard", highest: "Easy" }}
                        className="emoji"
                        required={true}
                        onChange={(name, value) => this.onChange(name, value)}
                    />
                </div>
                {this.renderRatingDetails()}
                {this.renderError()}
            </Toast.Body>
        );
    }

    render() {
        const { show, showRatingDetails } = this.state;
        const { page } = this.props;

        const classNames = ["feedback-rating"];
        if (showRatingDetails) {
            classNames.push("with-details");
        }

        return (
            <Toast
                id={page.toLowerCase()}
                className={classNames.join(" ")}
                bg="primary"
                show={show}
                onClose={(e) => this.onChange("rating", 0)}
            >
                <Toast.Header closeButton={true}>
                    <strong className="mr-auto">&nbsp;</strong>
                </Toast.Header>
                {this.renderContent()}
            </Toast>
        );
        // return (
        //     <Modal show={true}>
        //         <Modal.Header closeButton={true}></Modal.Header>
        //         {this.renderContent()}
        //     </Modal>
        // );
    }
}
